import React from 'react';
import { CountryCode } from '@dayetopia/library/types';
import { useCountry } from '@hooks/useCountry';

type Props = {};

const CompanyAddress: React.FC<Props> = () => {
  const year = new Date().getFullYear();
  const { country } = useCountry();

  if (country === CountryCode.US) {
    return (
      <>
        <p>© {year} Anne’s Day Inc</p>
        <p>2140 S.Dupont Highway,</p>
        <p>Camden, Delaware,</p>
        <p>19934</p>
      </>
    );
  }

  return (
    <>
      <p>© {year} Daye Limited</p>
      <p>CC110, Cocoa Studios</p>
      <p>The Biscuit Factory</p>
      <p>100 Drummond Road</p>
      <p>London, SE16 4DG, UK</p>
    </>
  );
};

export default CompanyAddress;
